<template>
  <div class="appBody bg-white min-height">
    <little-header></little-header>
    <van-empty
      class="custom-image"
      image="/static/img/pro/403.png"
      description="暂无访问权限"
    />
    <little-footer class="fixed-bottom max-w-640 m-auto"></little-footer>
  </div>

</template>

<script>
  import Vue from 'vue';
  import {Empty} from 'vant';
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";

  Vue.use(Empty);
  export default {
    name: "noRightPage",
    // props: [
    //   'text'
    // ],
    components: {
      LittleHeader,
      littleFooter,
    },
  }
</script>

<style scoped>

</style>
